import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=454f9f08&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=ts"
export * from "./CustomerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f9f08",
  null
  
)

export default component.exports